/**********************************************************************
 * WARNING: This file was autogenerated by util-protos generateFiles.js
 * Do not manually edit!
 ***********************************************************************/

import {createReactQueryHook} from '../types'
import {getCheckAddress} from '../api'

 export const useQueryGetCheckAddress = createReactQueryHook('getCheckAddress', getCheckAddress)
